// Copy paste this template to create a new component
// that can be put into the masonry layout!

import * as React from "react";
import Modal from "react-modal";
import { css } from "emotion";
import styled from "@emotion/styled";
import Card from "./Card";

import { colors, fonts, mediaQueries } from "../../shared/config";
import x from "../../shared/x.png";

const topStyle = {
  content: {
    width: "40%",
    margin: "auto",
    background: colors.white,
    fontFamily: fonts.textFont
  }
};

const Image = styled("img")`
  width: 100%;
  height: auto;
`;

const ImageHolder = styled("div")`
  width: 100%;
  height: auto;
  position: relative;
`;

const StaffHolder = styled("div")`
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 20px;
  padding: 20px;
  color: ${colors.white};
  background-color: black;
  @media (max-width: 700px) {
    padding: 10px;
    margin: 10px;
  }
`;

const Link = styled("div")`
  color: ${colors.darkblue};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

Modal.setAppElement("#root");

interface TestimonyCardProps {
  value: {
    staffName: string;
    staffPosition: string;
    quote: string;
    imageURL: string;
    imageAlt: string;
    testimony: {
      type: string;
      value: string;
    }[];
  };
}

interface TestimonyCardState {
  modalIsOpen: boolean;
}

class TestimonyCard extends React.Component<
  TestimonyCardProps,
  TestimonyCardState
> {
  constructor(props: TestimonyCardProps) {
    super(props);
    this.state = {
      modalIsOpen: false
    };
    this.setModalIsOpen = this.setModalIsOpen.bind(this);
  }

  setModalIsOpen(value: boolean) {
    this.setState({ modalIsOpen: value });
    console.log(this);
  }

  render() {
    const {
      staffName,
      staffPosition,
      quote,
      imageURL,
      imageAlt,
      testimony
    } = this.props.value;

    let { modalIsOpen } = this.state;

    const { mobile, notMobile, tablet } = mediaQueries;

    return (
      <Card>
        <ImageHolder>
          <Image src={imageURL} alt={imageAlt} />
          <StaffHolder>
            <div
              className={css`
                font-size: 32px;
                ${mobile} {
                  font-size: 20px;
                }
              `}
            >
              {staffName}
            </div>
            <div
              className={css`
                height: 2px;
                width: 50px;
                background-color: ${colors.white};
                margin: 10px 0px;
                ${mobile} {
                  margin: 3px 0;
                  height: 1px;
                }
              `}
            />
            <div
              className={css`
                font-size: 18px;
                ${mobile} {
                  font-size: 16px;
                }
              `}
            >
              {staffPosition}
            </div>
          </StaffHolder>
        </ImageHolder>
        <div
          className={css`
            font-size: 20px;
            margin: 20px;
            color: ${colors.black};
            text-align: center;
          `}
        >
          "{quote}"
        </div>
        <div
          className={css`
            text-align: center;
          `}
        >
          <Link onClick={() => this.setModalIsOpen(true)}>Read more</Link>
        </div>
        <div
          onClick={() => this.setModalIsOpen(false)}
          className={css`
            width: 100%;
            height: 100%;
            z-index: 999;
            position: fixed;
            background-color: ${!modalIsOpen
              ? "rgba(0, 0, 0, 0)"
              : "rgba(255, 255, 255, 0.7)"};
            top: 0;
            right: 0;
            pointer-events: ${modalIsOpen ? "auto" : "none"};
          `}
        ></div>
        <div
          className={css`
              position: fixed;
              bottom: 50%;
              left: 50%;
              transform: translate(-50%, 50%);
              pointer-events: ${modalIsOpen ? "auto" : "none"};
              /* display: ${modalIsOpen ? "block" : "none"}; */
              opacity: ${modalIsOpen ? 1 : 0};
              z-index: 1000;
            `}
        >
          <div
            className={css`
              height: 90vh;
              width: 40vw;
              ${tablet} {
                width: 60vw;
              }
              ${mobile} {
                width: 90vw;
              }
              padding: 10px;
              background-color: ${colors.lightgray};
              position: relative;
              overflow-y: scroll;
            `}
          >
            {/*^^^ CONTAINER */}
            <div
              className={css`
                top: 20px;
                right: 20px;
                height: 30px;
                width: 30px;
                z-index: 100000;
                background-color: black;
                border-radius: 50%;
                position: absolute;
                pointer-events: ${modalIsOpen ? "auto" : "none"};
                cursor: pointer;
                color: white;
              `}
              onClick={() => this.setModalIsOpen(false)}
            >
              <img
                src={x}
                className={css`
                  height: 100%;
                  width: 100%;
                  align-self: center;
                `}
              />
            </div>
            <div
              className={css`
                width: 100%;
                height: auto;
                background-color: ${colors.lightgray};
                position: relative;
              `}
            >
              <img
                className={css`
                  height: 100%;
                  width: 100%;
                  object-fit: cover;
                `}
                src={imageURL}
                alt={imageAlt}
              />
              <StaffHolder>
                <div
                  className={css`
                    font-size: 32px;
                    ${mobile} {
                      font-size: 20px;
                    }
                  `}
                >
                  {staffName}
                </div>
                <div
                  className={css`
                    height: 2px;
                    width: 50px;
                    background-color: ${colors.white};
                    margin: 10px 0px;
                    ${mobile} {
                      margin: 3px 0;
                      height: 1px;
                    }
                  `}
                />
                <div
                  className={css`
                    font-size: 18px;
                    ${mobile} {
                      font-size: 14px;
                    }
                  `}
                >
                  {staffPosition}
                </div>
              </StaffHolder>
            </div>
            <div
              className={css`
                width: 100%;
                height: auto;
                padding: 20px;
                box-sizing: border-box;
                background-color: ${colors.gray};
              `}
            >
              {testimony.map(item => {
                switch (item.type) {
                  case "text":
                    return (
                      <p
                        className={css`
                          font-style: "Nunito";
                        `}
                      >
                        {item.value}
                      </p>
                    );
                }
              })}
              <Link onClick={() => this.setModalIsOpen(false)}>Close</Link>
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

// don't forget to export!

export default TestimonyCard;
